var React = require('react');

function MenuAleMexjet (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.3439 20.6152V19.6145C15.7449 19.6145 15.8784 19.4143 16.1452 18.7472C16.3454 18.2801 16.3454 16.8791 16.3454 15.2779L27.3535 17.2794L26.9532 15.8784C26.8198 15.3446 26.6863 14.9444 25.9525 14.6108L15.3446 9.54037C15.2112 6.47144 15.6115 0.467011 13.6768 0C11.742 0.467011 12.1423 6.47144 12.0089 9.54037L1.40103 14.6108C0.667158 14.9444 0.533727 15.3446 0.400295 15.8784L0 17.2794L11.0081 15.2779C11.0081 16.8124 11.0081 18.2134 11.2083 18.7472C11.4751 19.4143 11.5418 19.6812 13.0096 19.6145V20.6152C13.0096 20.6152 8.53963 23.2838 8.4062 23.7508L8.13933 24.6849L13.6768 23.2838L19.2142 24.6849L18.9473 23.7508C18.8139 23.2838 14.3439 20.6152 14.3439 20.6152Z","fill":"white"}));
}

MenuAleMexjet.defaultProps = {"width":"28","height":"25","viewBox":"0 0 28 25","fill":"none"};

module.exports = MenuAleMexjet;

MenuAleMexjet.default = MenuAleMexjet;
